import DashboardRoutes from 'Arch/modules-pages/routes';
import AdministratorsRoutes from 'App/administrators/routes';
import ContaCardRoutes from 'Modules/contacard/routes';
import Users from 'App/users/routes';
import Dlq from 'App/dlq/routes';
import ArchivesCategory from 'App/archivesCategory/routes';

export default [
  {
    path: '/',
    component: () => import('Arch/template/Template.vue'),
    children: [
      ...DashboardRoutes,
      ...ContaCardRoutes,
      ...Users,
      ...AdministratorsRoutes,
      ...ArchivesCategory,
      ...Dlq,
    ],
  },
  {
    path: '/login',
    component: () => import('App/login/Layout.vue'),
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('App/login/components/Login.vue'),
      },
      {
        path: 'recover',
        name: 'RecoverPassword',
        component: () => import('App/login/components/RecoverPassword.vue'),
      },
      {
        path: 'recover-success',
        name: 'RecoverSuccess',
        component: () => import('App/login/components/RecoverSuccess.vue'),
        props: true,
      },
      {
        path: 'new-password/:token',
        name: 'NewPassword',
        component: () => import('App/login/components/NewPassword.vue'),
      },
    ],
  },
];
